import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import SearchParams from "simplydo/core/searchParams";
import type { UserMe } from "simplydo/interfaces/types/userTypes";

import api from "api";

export const useMe = (): UserMe | undefined => {
  const utmReferrer =
    typeof window !== "undefined" && window.location
      ? new SearchParams(window.location.search).get("utm-link")
      : undefined;
  const { data: me } = useQuery(
    initUseQuery(api.users.me, [utmReferrer ?? ""]),
  );

  return me as UserMe | undefined;
};
